export default "__VITE_ASSET__59LXkPou__"